import { render, staticRenderFns } from "./BSSetSaleAmountCombined.vue?vue&type=template&id=26216546"
import script from "./BSSetSaleAmountCombined.vue?vue&type=script&lang=js"
export * from "./BSSetSaleAmountCombined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports